import React from 'react';
import PropTypes from 'prop-types';

const EmptyLayout = (props) => (
  <div className="container">
    <div className="row">
      {props.children}
    </div>
  </div>
);

EmptyLayout.propTypes = {
  children: PropTypes.any
};

export default EmptyLayout;
